import { Card } from '@tribeplatform/react-ui-kit/Card'

import { BC } from '../../types/index.js'
import { CardProps } from './types.js'

export const CardBlock: BC<CardProps> = Card
